import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  // 获客阶段
  {
    path: '/problem-communicate',
    name: 'problem-communicate',
    meta: {
      index: 0,
    },
    component: () => import('../views/solveProblems/communicate.vue')
  },
  {
    path: '/problem-overseas-inspection',
    name: 'problem-overseas-inspection',
    meta: {
      index: 0,
    },
    component: () => import('../views/solveProblems/overseasInspection.vue')
  },
  {
    path: '/problem-customer-inform',
    name: 'problem-customer-inform',
    meta: {
      index: 0,
    },
    component: () => import('../views/solveProblems/customerInform.vue')
  },
  {
    path: '/problem-domestic-team',
    name: 'problem-domestic-team',
    meta: {
      index: 0,
    },
    component: () => import('../views/solveProblems/domesticTeam.vue')
  },
  {
    path: '/problem-customer-respond',
    name: 'problem-customer-respond',
    meta: {
      index: 0,
    },
    component: () => import('../views/solveProblems/customerRespond.vue')
  },
  {
    path: '/problem-low-cost',
    name: 'problem-low-cost',
    meta: {
      index: 0,
    },
    component: () => import('../views/solveProblems/lowCost.vue')
  },
  {
    path: '/problem-customer-contact',
    name: 'problem-customer-contact',
    meta: {
      index: 0,
    },
    component: () => import('../views/solveProblems/customerContact.vue')
  },
  {
    path: '/problem-target-customer',
    name: 'problem-target-customer',
    meta: {
      index: 0,
    },
    component: () => import('../views/solveProblems/targetCustomer.vue')
  },
  {
    path: '/problem-overseas-market',
    name: 'problem-overseas-market',
    meta: {
      index: 0,
    },
    component: () => import('../views/solveProblems/overseasMarket.vue')
  },
  // 商机转化阶段
  {
    path: '/problem-demonstrate-cost',
    name: 'problem-demonstrate-cost',
    meta: {
      index: 0,
    },
    component: () => import('../views/solveProblems/demonstrateCost.vue')
  },
  {
    path: '/problem-business-mastery',
    name: 'problem-business-mastery',
    meta: {
      index: 0,
    },
    component: () => import('../views/solveProblems/businessMastery.vue')
  },
  {
    path: '/problem-unclear-demand',
    name: 'problem-unclear-demand',
    meta: {
      index: 0,
    },
    component: () => import('../views/solveProblems/unclearDemand.vue')
  },
  {
    path: '/problem-efficient-response',
    name: 'problem-efficient-response',
    meta: {
      index: 0,
    },
    component: () => import('../views/solveProblems/efficientResponse.vue')
  },
  {
    path: '/problem-travel-expenses',
    name: 'problem-travel-expenses',
    meta: {
      index: 0,
    },
    component: () => import('../views/solveProblems/travelExpenses.vue')
  },
  {
    path: '/problem-major-impression',
    name: 'problem-major-impression',
    meta: {
      index: 0,
    },
    component: () => import('../views/solveProblems/majorImpression.vue')
  },
  {
    path: '/problem-business-promote',
    name: 'problem-business-promote',
    meta: {
      index: 0,
    },
    component: () => import('../views/solveProblems/businessPromote.vue')
  },
  {
    path: '/problem-challenge-respond',
    name: 'problem-challenge-respond',
    meta: {
      index: 0,
    },
    component: () => import('../views/solveProblems/challengeRespond.vue')
  },
  {
    path: '/problem-opponent-impact',
    name: 'problem-opponent-impact',
    meta: {
      index: 0,
    },
    component: () => import('../views/solveProblems/opponentImpact.vue')
  },
  {
    path: '/tools',
    name: 'Tools',
    meta: {
      index: 2,
    },
    component: () => import('../views/Tools.vue')
  },
  // {
  //   path: '/AIbuilding',
  //   name: 'AIbuilding',
  //   component: () => import('../views/AIbuilding.vue')
  // },
  // {
  //   path: '/business',
  //   name: 'Business',
  //   component: () => import('../views/Business.vue')
  // },
  // {
  //   path: '/pre-sales',
  //   name: 'Pre-sales',
  //   component: () => import('../views/PreSales.vue')
  // },
  {
    path: '/about',
    name: 'About',
    meta: {
      index: 4,
    },
    component: () => import('../views/About.vue')
  },
  // {
  //   path: '/pricing',
  //   name: 'Pricing',
  //   component: () => import('../views/Pricing.vue')
  // },
  {
    path: '/contact',
    name: 'Contact',
    meta: {
      index: 4,
    },
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/contact/thanks',
    name: 'Thanks',
    component: () => import('../views/Thanks.vue')
  },
  {
    path: '/Services',
    name: 'Services',
    meta: {
      index: 1,
    },
    component: () => import('../views/Services.vue')
  },
  {
    path: '/faq',
    name: 'Faq',
    meta: {
      index: 5,
    },
    component: () => import('../views/Faq.vue')
  },
  {
    path: '/supportTools',
    name: 'SupportTools',
    meta: {
      index: 2,
    },
    component: () => import('../views/SupportTools.vue')
  },
  {
    path: '/developTools',
    name: 'DevelopTools',
    meta: {
      index: 2,
    },
    component: () => import('../views/DevelopTools.vue')
  },
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    meta: {
      index: -1,
    },
    component: () => import('../views/PrivacyPolicy.vue')
  },
  {
    path: '/useTerms',
    name: 'useTerms',
    meta: {
      index: -1,
    },
    component: () => import('../views/UseTerms.vue')
  },
  {
    path: '/solutionGenerationPlatform',
    name: 'solution',
    meta: {
      index: 2,
    },
    component: () => import('../views/supportProducts/solution.vue')
  },
  {
    path: '/painPoints',
    name: 'painPoints',
    meta: {
      index: 2,
    },
    component: () => import('../views/supportProducts/painPoints.vue')
  },
  {
    path: '/simulation',
    name: 'simulation',
    meta: {
      index: 2,
    },
    component: () => import('../views/supportProducts/simulation.vue')
  },
  {
    path: '/training',
    name: 'training',
    meta: {
      index: 2,
    },
    component: () => import('../views/supportProducts/training.vue')
  },
  {
    path: '/marketAnalytics',
    name: 'marketAnalytics',
    meta: {
      index: 2,
    },
    component: () => import('../views/developProducts/marketAnalytics.vue')
  },
  {
    path: '/globalCustomer',
    name: 'globalCustomer',
    meta: {
      index: 2,
    },
    component: () => import('../views/developProducts/globalCustomer.vue')
  },
  {
    path: '/customerInsights',
    name: 'customerInsights',
    meta: {
      index: 2,
    },
    component: () => import('../views/developProducts/customerInsights.vue')
  },
  {
    path: '/smartPoster',
    name: 'smartPoster',
    meta: {
      index: 2,
    },
    component: () => import('../views/developProducts/smartPoster.vue')
  },
  {
    path: '/productPopularize',
    name: 'productPopularize',
    meta: {
      index: 2,
    },
    component: () => import('../views/developProducts/productPopularize.vue')
  },
  {
    path: '/speechTranslator',
    name: 'speechTranslator',
    meta: {
      index: 2,
    },
    component: () => import('../views/developProducts/speechTranslator.vue')
  },
  {
    path: '/smartEmail',
    name: 'smartEmail',
    meta: {
      index: 2,
    },
    component: () => import('../views/developProducts/smartEmail.vue')
  },
  {
    path: '/strategyCoach',
    name: 'strategyCoach',
    meta: {
      index: 2,
    },
    component: () => import('../views/developProducts/strategyCoach.vue')
  },
  {
    path: '/emailStrategy',
    name: 'emailStrategy',
    meta: {
      index: 2,
    },
    component: () => import('../views/developProducts/emailStrategy.vue')
  },
  {
    path: '/AI_Translation',
    name: 'aiTranslation',
    meta: {
      index: 2,
    },
    component: () => import('../views/developProducts/aiTranslation.vue')
  },
  {
    path: '/Robot',
    name: 'robot',
    meta: {
      index: 3,
    },
    component: () => import('../views/Robot.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


// 解决重复点击导航时，控制台出现报错
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router
